import {Box, Typography} from '@viptech/react-components'
import ReactPlayer from 'react-player'
import usePersonalizedThemeByCompany from 'src/hooks/usePersonalizedThemeByCompany'

const DguardGuide = () => {
  const service = '{"device_name":"$camera.name$"}'

  const {styledTheme} = usePersonalizedThemeByCompany()
  return (
    <Box display='flex' direction='column' backgroundColor='white' borderRadius='8px' padding='30px' overflow='auto' rowGap='30px'>
      <Box>
        <Typography variant='p' size='16px' weight={700} color={styledTheme.colors.primary}>
          Tutorial de integração D-guard com o Brain!
        </Typography>
        <Typography variant='span' size='14px' color={'#5e6168'}>
          Abaixo você encontra um passo-a-passo com informações adicionais para configurar seu vms e um vídeo explicando de forma detalhada como completar a
          integração.
        </Typography>
      </Box>

      <Box display='flex' direction='column' rowGap='10px'>
        <Typography variant='p' size='14px'>
          1. Habilite o envio de requisição HTTP
        </Typography>

        <Typography variant='p' size='14px'>
          2. No campo Método, mantenha "POST"
        </Typography>

        <Typography variant='p' size='14px'>
          3. No campo URL, insira o seguinte link: <b>{process.env.REACT_APP_BASE_URL}/dguard-integration/trigger</b>
        </Typography>

        <Typography variant='p' size='14px'>
          4. No campo Autenticação, mantenha "Basic"
        </Typography>

        <Typography variant='p' size='14px'>
          5. Nos campos "Usuário" e "Senha" devem ser inseridas as credenciais de acesso pragmático geradas na plataforma do Brain
        </Typography>

        <Typography variant='p' size='14px'>
          6. No campo cabeçalho, insira o seguinte conteúdo: <b>Content-type: application/json</b>
        </Typography>

        <Typography variant='p' size='14px'>
          7. Por fim, no campo "Corpo", deve ser inserido o seguinte valor: {service}
        </Typography>
      </Box>

      <Box margin='10px'>
        <Typography variant='p' size='14px' weight={500}>
          O vídeo a seguir explica de forma detalhada os passos para completar a integração:
        </Typography>
        <ReactPlayer url='https://www.youtube.com/watch?v=uaMskbxaAP0' controls={true} />
      </Box>
    </Box>
  )
}

export default DguardGuide
